import angular, {IAngularEvent, IHttpResponse, ILocationService, IScope, ITimeoutService} from "angular";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {BrukerInaktivitetTjeneste, Inaktivitetsmonitor} from "felles/tjenester/BrukerInaktivitet";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {LoggUtEtterInaktivitetAdvarselKontroller} from "../moduler/innlogging/modale/loggUtEtterInaktivitetAdvarsel/loggUtEtterInaktivitetAdvarsel";
import {Debugger} from 'debug'
import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {l} from "../../types/typescriptdefinisjoner_lederplan";
import {InterWindowBus} from "../../felles/tjenester/InterWindowBus";
import {httpUnauthorizedEvent, stateManglendeTilgangsnivåEvent} from "../../felles/infrastruktur/Tilgangshaandtering";
import {StateDeclaration} from "@uirouter/core/lib/state/interface";
import _ from "lodash";

const debug: Debugger = require('debug')('Utlogging');

export class Utlogging {

    static regNavn = "wt.Utlogging";

    static forInjisering() {
        return [
            Autentisering.regNavn,
            WebNavigasjon.regNavn,
            BrukerInaktivitetTjeneste.regNavn,
            InterWindowBus.regNavn,
            Konfigurasjon.regNavn,
            regNavn.md.$mdDialog,
            regNavn.ng.$rootScope,
            regNavn.ng.$timeout,
            regNavn.ng.$location,
            Utlogging
        ];
    }

    constructor(private autentisering: Autentisering,
                private navigasjon: WebNavigasjon,
                private brukerInaktivitetTjeneste: BrukerInaktivitetTjeneste,
                private interWindowBus: InterWindowBus,
                private konfigurasjon: Konfigurasjon,
                private $mdDialog: angular.material.IDialogService,
                private $rootScope: IScope,
                private $timeout: ITimeoutService,
                private $location: ILocationService) {
    }

    private loggUtEtterInaktivitetTimer: Inaktivitetsmonitor;

    loggUt() {
        let aktivSide = this.$location.url();
        let logutPromise = this.autentisering.loggUt();
        //vi venter ikke med å redirigere til innloggingssiden til logut-kallet har returnert, vi ønsker å avbryte eventuelle pågående operasjoner så raskt som mulig
        //og antar at logut-kallet returnerer uten feil
        this.navigasjon.gåTilInnloggingssiden(aktivSide);
        return logutPromise;
    }

    startLoggUtEtterInaktivitetTimer() {
        //sørger for at vi ikke er sårbare for multiple kall til start
        this.stoppLoggUtEtterInaktivitetTimer();

        this.loggUtEtterInaktivitetTimer = this.brukerInaktivitetTjeneste
          .opprett(this.konfigurasjon.maksInaktivitetFørVarsel, () => this.vedInaktivitetTimeout())
          .start();
    }

    stoppLoggUtEtterInaktivitetTimer() {
        if (!this.loggUtEtterInaktivitetTimer) return;
        this.loggUtEtterInaktivitetTimer.stopp();
    }

    loggUtVedHendelser(){
        this.lyttTilBrukerLoggetUtEventIAnnenFane();
        this.lyttTilManglendeTilgangEvent();
    }

    //hjelpemetoder

    /** vis dialog som varsler om snarlig utlogging */
    private vedInaktivitetTimeout() {
        this.loggUtEtterInaktivitetTimer.stopp();
        this.visUtloggingsvarsel();
    }

    private visUtloggingsvarsel() {
        LoggUtEtterInaktivitetAdvarselKontroller.visLoggUtEtterInaktivitetAdvarsel(
          this.loggUtEtterInaktivitetTimer.inaktivitetVarighet(),
          this.konfigurasjon.inaktivitetVarselTimeout,
          this.$mdDialog)
          .then(
            (tokenvarighet: l.Tokenvarighet) => this.vedAvbrytUtlogging(tokenvarighet),
            () => this.logUtPåGrunnAvInaktivitet())
          .catch(_.noop);
    }

    private logUtPåGrunnAvInaktivitet(){
        debug('logUtPåGrunnAvInaktivitet');
        this.loggUt();
    }

    private vedAvbrytUtlogging(tokenvarighet: l.Tokenvarighet){
        switch (tokenvarighet){
            case l.Tokenvarighet.kort: this.forsettMedKortToken(); break;
            case l.Tokenvarighet.medium: this.oppgraderTilMediumTokenvarighet(); break;
        }
    }

    /** Trenger ikke å gjøre noe annet enn å sørge for at timeren som viser utliggings-varsel-dialogen vises.
     * Merk at selve tokenfornyelsen håndteres i {@link Autentisering#startAutomatiskKortTokenfornyelse} */
    private forsettMedKortToken(){
        this.loggUtEtterInaktivitetTimer.start();
    }

    /** Sørger for å oppgradere til medium tokenvarighet */
    private oppgraderTilMediumTokenvarighet(){
        this.autentisering.oppgraderTilMediumToken();
    }

    /** Sørger for å logg ut bruker lokalt og gå til innloggingsside når bruker har logget ut i en annen fane */
    private lyttTilBrukerLoggetUtEventIAnnenFane() {
        this.interWindowBus.ved(Autentisering.brukerLoggetUtEvent, () => {
            debug("lyttTilBrukerLoggetUtEventIAnnenFane");
            this.autentisering.lokalLoggUt(false);
            this.navigasjon.gåTilInnloggingssiden(this.$location.url())
        });
    }

    /** Sørger for å logg ut bruker og gå til innloggingsside ved 401 (ikke autentisert) og stateManglendeTilgangsnivåEvent-hendelse */
    private lyttTilManglendeTilgangEvent() {
        this.$rootScope.$on(httpUnauthorizedEvent, (event: IAngularEvent, rejection: IHttpResponse<any>) => {
            //ressurskall returnerte 401 (ikke autentisert)
            //invaliderer lokal kontekst og viser innloggingssiden
            debug('httpUnauthorizedEvent - redirect til login pga http %s respons ved kall til %s', rejection.status, rejection.config.url);
            this.autentisering.lokalLoggUt();
            this.navigasjon.gåTilInnloggingssiden();
        });
        this.$rootScope.$on(Autentisering.tokenValideringFeiletEvent, (event: IAngularEvent, tokeninfo:l.ValiderTokenModell) => {
            //validering av token feilet (token utløpt)
            //invaliderer lokal kontekst og viser innloggingssiden
            debug('tokenValideringFeiletEvent - redirect til login pga ugyldig token');
            this.autentisering.lokalLoggUt();
            this.navigasjon.gåTilInnloggingssiden();
        });
        this.$rootScope.$on(stateManglendeTilgangsnivåEvent,(event: IAngularEvent, fraState: StateDeclaration, tilState: StateDeclaration) => {
            //bruker er enten ikke logget inn eller prøver å aksessere en state som krever en TilgansrollerBruker som innlogget bruker ikke har
            //redirigerer til innloggingssiden som så vil vise innloggingskjema eller redirigere til standard innholdsside dersom bruker er innlogget
            debug('stateManglendeTilgangsnivåEvent - redirect til login pga !kontekst.harTilgangTilState ved navigasjon til %s fra %s', tilState.name, fraState.name);
            this.navigasjon.gåTilInnloggingssiden(this.$location.url());
        });
    }

}
